interface IProps {
  tagContent: string;
}

const DisplayTagPreview = ({ tagContent }: IProps) => {
  return (
    <div className='w-full'>
      <iframe
        srcDoc={tagContent}
        sandbox='allow-scripts'
        className='w-full h-[400px] border border-gray-200 rounded-lg bg-white'
        title='Display tag preview'
      />
    </div>
  );
};

export default DisplayTagPreview;
